export const USER_PROFILE_STATE = 'userBookings'

export const USER_BOOKINGS_REQUEST = 'USER_BOOKINGS_REQUEST'
export const USER_BOOKINGS_SUCCESS = 'USER_BOOKINGS_SUCCESS'
export const USER_BOOKINGS_FAILED = 'USER_BOOKINGS_FAILED'
